export default (user) => {
    return sessionStorage.setItem('app_user', user)
}